module.exports = __webpack_public_path__ + "static/media/iconTransmissionActive.4d22582c.svg";